import React, { createContext, useContext } from 'react';

const ActionScopeContext = createContext('event');

export const ActionScopeProvider = ({ scope = 'event', children }) => (
  <ActionScopeContext.Provider value={scope || 'event'}>
    {children}
  </ActionScopeContext.Provider>
);

export const useActionScope = () => useContext(ActionScopeContext) || 'event';

export default ActionScopeContext;
